import { ICopyable } from '../controls/common/icopyable';
import { OverrideCondition } from './enums/override-condition';

export class OverridedAttribute implements ICopyable<OverridedAttribute> {
    attributeId: number = null;
    condition: OverrideCondition = null;

    public createCopy(): OverridedAttribute {
        const instance = new OverridedAttribute();
        instance.attributeId = this.attributeId;
        instance.condition = this.condition;

        return instance;
    }

    public copyFrom(other: any) {
        this.attributeId = other.attributeId;
        this.condition = other.condition;
    }
}
